<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>检查：全部数据一起检查，数据较多的时候花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>检查并导入：全部数据一起检查并导入，数据较多的时候花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">服务名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">服务标题</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">服务类型</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中选择</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">服务用途</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中选择</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">规格名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">规格说明</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">上门费(元)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">参考人工费(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">服务费(元)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">要求质保时长(天)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">要求响应时长(分钟)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">要求到达时长(分钟)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">要求维修时长(分钟)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">电话回询时限(分钟)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中编辑</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">配件名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">配件规格</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">价格下限(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">价格上限(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中编辑</div>
                    <div class="table-td">-</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    export default {
        name: 'swb-servc-format-expl',
        desc: '服务项目导入文件格式说明',
        props: {
            scopeId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/ServcFormatExpl.vue